<template>
    <div class="content">
        <div v-if="video !== ''">
            <video v-bind:src="video" controls></video>
        </div>
        <div v-else-if="image !== ''">
            <img v-bind:src="image">
        </div>
        <div v-else>
            <p>{{title}}</p>
        </div>
    </div>
</template>

<script>
export default {
  props: ['url'],
  data: () => ({
    title: '',
    image: '',
    video: ''
  }),
  created: function () {
    this.fetchOGP(this.url)
  },
  methods: {
    fetchOGP (url) {
      fetch(url).then(res => res.text())
        .then(text => {
          const el = new DOMParser().parseFromString(text, 'text/html')
          const headEls = (el.head.children)
          Array.from(headEls).map(v => {
            const prop = v.getAttribute('property')
            if (!prop) return
            //   console.log(prop, v.getAttribute('content'))
            const content = v.getAttribute('content')
            if (prop === 'og:title') {
              this.title = content
            }
            if (prop === 'og:image') {
              this.image = content
            }
            if (prop === 'og:video') {
              this.video = content
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
p {
    color: #000;
}
.content img {
    width: 100%;
    height: auto;
}

.content video {
    width: 100%;
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/OGPContent.vue